export default __webpack_public_path__ + "static/media/search.5e71efd5.svg";